import { isPartnerHelper, NameInitials } from '../../helpers/helperFunctions';

import { useWindowWide } from '../../helpers/wideScreen';
import { H3, H5, P1 } from '../../styles/FontStyles';
import {
  Box,
  Flexed,
  ProfileImage,
  ProfileImagePlaceholder,
  ProfilePicture
} from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';

import { Link, useHistory } from 'react-router-dom';
import { Desktop, Mobile } from '../../App';
import { Button } from '../../components';
import {
  CHOOSE_SUBSCRIPTION,
  EARNINGS,
  ENTRY_PACKAGE,
  MY_HUBS_GUARDIAN,
  MY_TEAM,
  ORDERS,
  RANKING,
  RESOURCES
} from '../../routes/routes';
import { Icon, IconUpgradeToCustomer } from '../../styles/Icons';
import { User, UserInfoType } from '../../types/loginTypes';
import { useEffect } from 'react';
import axios from 'axios';
import { getUserFromLS, setUserToLS } from '../../helpers/localstorage-helper';

interface DashboardNavProps {
  user: User;
  userInfo: UserInfoType;
}

export const DashboardNav = ({ user, userInfo }: DashboardNavProps) => {
  const wide = useWindowWide(800);

  const isPartner = isPartnerHelper(
    user?.currentVirtualOfficeLicence?.dateEnd || ''
  );

  const history = useHistory();

  const getUserInfo = async () => {
    const { data } = await axios.get(`/user/info`);

    if (data?.data?.hasPaidPackage) {
      history.push(MY_HUBS_GUARDIAN);
    } else {
      history.push(ENTRY_PACKAGE);
    }
  };

  return (
    <>
      <div>
        {!isPartner && (
          <Flexed gap='10px' center mb='30'>
            <ProfilePicture size={wide ? '70px' : '64px'}>
              {user?.profileImageUrl ? (
                <ProfileImage src={user?.profileImageUrl} alt='Upload' />
              ) : (
                <ProfileImagePlaceholder
                  size={window.innerWidth > 800 ? '70px' : '64px'}
                  font={window.innerWidth > 800 ? '24px' : '20px'}>
                  {NameInitials()}
                </ProfileImagePlaceholder>
              )}
            </ProfilePicture>
            <div>
              <P1 color={colors.primary900}>Welcome back,</P1>
              <P1 bold color={colors.primary900}>
                {user?.name ?? '---'}
              </P1>
            </div>
          </Flexed>
        )}

        <div>
          {isPartner && (
            <Link to={MY_TEAM}>
              <Box
                border
                p='15px 30px'
                pSM='15px 25px'
                br='30px'
                mb='20'
                mbSM='10'>
                <Desktop>
                  <H3 color={colors.primary900}>My Organization</H3>
                </Desktop>
                <Mobile>
                  <H5 fontFamily='Nulshock' color={colors.primary900}>
                    My Organization
                  </H5>
                </Mobile>
              </Box>
            </Link>
          )}

          {isPartner && (
            <Link to={EARNINGS}>
              <Box
                border
                p='15px 30px'
                pSM='15px 20px'
                br='30px'
                mb='20'
                mbSM='10'>
                <Desktop>
                  <H3 color={colors.primary900}>My Earnings</H3>
                </Desktop>
                <Mobile>
                  <H5 fontFamily='Nulshock' color={colors.primary900}>
                    My Earnings
                  </H5>
                </Mobile>
              </Box>
            </Link>
          )}

          {/* <Link
            to={userInfo?.hasPaidPackage ? MY_HUBS_GUARDIAN : ENTRY_PACKAGE}> */}
          <Box
            border
            p='15px 30px'
            pSM='15px 20px'
            br='30px'
            mb='20'
            mbSM='10'
            onClick={() => getUserInfo()}
            style={{ cursor: 'pointer' }}>
            <Desktop>
              <H3 color={colors.primary900}>My Products</H3>
            </Desktop>
            <Mobile>
              <H5 fontFamily='Nulshock' color={colors.primary900}>
                My Products
              </H5>
            </Mobile>
          </Box>
          {/* </Link> */}

          <Link to={ORDERS}>
            <Box
              border
              p='15px 30px'
              pSM='15px 20px'
              br='30px'
              mb='20'
              mbSM='10'>
              <Desktop>
                <H3 color={colors.primary900}>My Orders</H3>
              </Desktop>
              <Mobile>
                <H5 fontFamily='Nulshock' color={colors.primary900}>
                  My Orders
                </H5>
              </Mobile>
            </Box>
          </Link>

          {isPartner && (
            <Link to={RESOURCES}>
              <Box
                border
                p='15px 30px'
                pSM='15px 20px'
                br='30px'
                mb='20'
                mbSM='10'>
                <Desktop>
                  <H3 color={colors.primary900}>My Resources</H3>
                </Desktop>
                <Mobile>
                  <H5 fontFamily='Nulshock' color={colors.primary900}>
                    My Resources
                  </H5>
                </Mobile>
              </Box>
            </Link>
          )}

          {isPartner && (
            <Link to={RANKING}>
              <Box
                border
                p='15px 30px'
                pSM='15px 20px'
                br='30px'
                mb='20'
                mbSM='10'>
                <Desktop>
                  <H3 color={colors.primary900}>My Rankings</H3>
                </Desktop>
                <Mobile>
                  <H5 fontFamily='Nulshock' color={colors.primary900}>
                    My Rankings
                  </H5>
                </Mobile>
              </Box>
            </Link>
          )}

          {/* {isPartner && (
            <Link to={SUPPORT_TICKETS}>
              <Box
                border
                p='15px 30px'
                pSM='15px 20px'
                br='30px'
                mb='20'
                mbSM='10'>
                <Desktop>
                  <H3 color={colors.primary900}>Support</H3>
                </Desktop>
                <Mobile>
                  <H5 fontFamily='Nulshock' color={colors.primary900}>
                    Support
                  </H5>
                </Mobile>
              </Box>
            </Link>
          )} */}
        </div>

        <Link to={ENTRY_PACKAGE}>
          <Box border p='15px 30px' pSM='15px 20px' br='30px' mb='0' mbSM='0'>
            <Desktop>
              <H3 color={colors.primary900}>Buy Package</H3>
            </Desktop>
            <Mobile>
              <H5 fontFamily='Nulshock' color={colors.primary900}>
                Buy Package
              </H5>
            </Mobile>
          </Box>
        </Link>

        {!isPartner && (
          <Link to={CHOOSE_SUBSCRIPTION}>
            <Button mt='20'>
              <Flexed justifyCenter>
                {' '}
                <Icon mr='10'>
                  {' '}
                  <IconUpgradeToCustomer />
                </Icon>
                Upgrade To Partner
              </Flexed>
            </Button>
          </Link>
        )}
        {/* {isPartner && (
          <Box border mt='20'>
            <Flexed between>
              <P2 bold mb='5'>
                {moment(user?.currentVirtualOfficeLicence?.dateEnd).format(
                  'DD/MM/YYYY'
                )}
              </P2>
              <CaptionText bold color={colors.primary900}>
                Active
              </CaptionText>
            </Flexed>
            <Button style={{ height: 30, width: 90 }}>Renew</Button>
          </Box>
        )} */}
      </div>
    </>
  );
};
